import React, { useEffect, useRef } from "react"
import EmblaCarouselGallery from "../EmblaCarouselGallery"
import RichText from "../RichText"
import DownloadCard from "../_Atoms/DownloadCard"
import LogoNetZero from "../_Atoms/LogoNetZero"

function Modal(props) {
  const { isModalOpen, setIsModalOpen, modalContent, video, progressVideo } =
    props || {}

  const modal = useRef()

  const videoID = modalContent === "progressVideo" ? progressVideo : video

  useEffect(() => {
    modal.current.scrollTop = 0
  }, [modalContent])

  return (
    <div
      className={`fixed inset-0 z-100 w-full flex h-screen  bg-lcygray-500/80  transform transition-all duration-300 ${
        isModalOpen
          ? "opacity-100 translate-y-0"
          : "opacity-0 pointer-events-none translate-y-full"
      }`}
    >
      <div className="flex w-full h-screen">
        <div
          ref={modal}
          className="relative m-auto block h-auto w-11/12 max-w-lg flex-row overflow-y-auto overscroll-contain bg-white p-8 text-left text-black rounded-[2.4rem] max-h-[90vh] md:flex md:p-16"
        >
          <button
            className="sticky top-0 right-0 z-10 order-last size-16 shrink-0 p-5 ml-auto text-white transition-transform duration-300 transform bg-black rounded-full left-full md:translate-x-12 md:-translate-y-12 hover:md:rotate-90 hover:md:text-white cursor-pointer"
            aria-label="Close modal"
            onClick={() => setIsModalOpen(!isModalOpen)}
          >
            <svg
              className="w-full h-full mx-auto fill-current"
              viewBox="0 0 15 15"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.3086 2.82843L11.4802 0L7.31273 4.37848L3.3086 0.171573L0.480169 3L4.55247 7.27852L0.449219 11.5896L3.27765 14.418L7.31274 10.1786L11.5111 14.5896L14.3396 11.7611L10.073 7.27852L14.3086 2.82843Z"
              />
            </svg>
          </button>
          <div className="relative order-first block w-full h-full pt-8 md:pt-0">
            {modalContent === "video" || modalContent === "progressVideo" ? (
              <div className="my-auto">
                <iframe
                  className="w-full my-auto aspect-video rounded-3xl"
                  src={
                    isModalOpen
                      ? `https://www.youtube.com/embed/${videoID}`
                      : ""
                  }
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
                <p className="mt-8 text-xs text-right">
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    className="underline hover:lg:text-lcygray-500"
                    href={`https://www.youtube.com/watch?v=${videoID}`}
                  >
                    Watch on YouTube
                  </a>
                </p>
              </div>
            ) : (
              <>
                {modalContent?.logoOverride ? (
                  <>
                    <LogoNetZero className="!w-[14rem] mb-12" />
                    <h2 className="sr-only">{modalContent?.title}</h2>
                  </>
                ) : (
                  modalContent?.title && <h2 className="mb-16 leading-none">{modalContent?.title}</h2>
                )}
                {modalContent?.subtitle && <h3>{modalContent?.subtitle}</h3>}
                {modalContent?.content ? (
                  <div
                    className={`my-8 content ${
                      modalContent?.downloads ? "max-w-4xl" : ""
                    }`}
                  >
                    <RichText data={modalContent?.content} />
                  </div>
                ) : null}

                {modalContent?.gallery ? (
                  <EmblaCarouselGallery
                    isModalOpen={isModalOpen}
                    gallery={modalContent?.gallery}
                  />
                ) : null}

                {modalContent?.contentSecondary ? (
                  <div className="content">
                    <RichText data={modalContent?.contentSecondary} />
                  </div>
                ) : null}

                {modalContent?.downloads ? (
                  <div className={"flex flex-col md:flex-row gap-12 mt-16"}>
                    {modalContent?.downloads.map((download) => (
                      <>
                        {console.log(download)}
                        <DownloadCard data={download} key={download.id} />
                      </>
                    ))}
                  </div>
                ) : null}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Modal
